<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">
          {{ $tc('delete_ip') }}?
        </v-card-title>
        <v-card-text>
          {{ $t('confirm_ip_delete') }}
          <strong>{{ ip }}</strong>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="green darken-1" text @click.native="closeModal">
            {{ $t('cancel') }}
          </v-btn>
          <v-btn color="text_red" text @click.native="deleteIp">
            {{ $t('confirm') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>

const operationMode = 0

export default {
  props: {
    ip: {
      type: String,
      required: false,
      default: () => null
    },
    open: {
      type: Boolean,
      required: false,
      default: () => false
    }
  },
  data () {
    return {
      dialog: this.open
    }
  },
  methods: {
    closeModal () {
      this.dialog = false
      this.$emit('close')
    },
    deleteIp () {
      this.$store
        .dispatch('hsm/update_ntp', {
          body: {
            add: operationMode,
            ip: this.ip
          }
        })
        .then(() => {
          this.$notify.success({})
        })
        .catch(err => {
          const errObj = this.$store.getters['error/getErrorObj'](err)
          if (errObj) {
            this.$notify.hsmError(errObj, err)
          } else {
            this.$notify.error({ message: err })
          }
        })
        .finally(() => {
          this.loading = false
          this.closeModal()
        })
    }
  },
  watch: {
    open (val) {
      this.dialog = val
    }
  }
}
</script>
